/**
 * Cliente API del importador CSV matricial de pagos iniciales.
 *
 * Sprint 15 S15-03. Solo super_admin puede ejecutar el import.
 */
import { apiFetch } from './client';

export interface ErrorFila {
  numero_fila: number;
  casa: string | null;
  motivo: string;
}

export interface FilaSkipDefensiva {
  numero_fila: number;
  casa: string;
  detalle: string;
}

export interface ImportarPagosInicialesPayload {
  csv_contenido: string;
  dry_run?: boolean;
}

export interface ImportarPagosInicialesResponse {
  modo: 'dry_run' | 'real';
  filas_procesadas: number;
  filas_con_error: number;
  cuotas_arrastre_creadas: number;
  pagos_abono_deuda_creados: number;
  pagos_saldo_favor_creados: number;
  pagos_mensuales_creados: number;
  distribuciones_creadas: number;
  skips_defensivos: FilaSkipDefensiva[];
  errores: ErrorFila[];
}

export function importarPagosIniciales(
  payload: ImportarPagosInicialesPayload,
): Promise<ImportarPagosInicialesResponse> {
  return apiFetch<ImportarPagosInicialesResponse>('/pagos/import-csv-inicial', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/**
 * Genera contenido CSV vacío con los 16 headers esperados por el
 * importador. El operador descarga este archivo, lo abre en Excel y lo
 * rellena con la planilla del tesorero.
 */
export function generarPlantillaCsv(): string {
  return (
    'casa,deuda_2025,a_deuda,ene,feb,mar,abr,may,jun,jul,ago,sep,oct,nov,dic,notas\n'
  );
}
